import { Injectable } from '@angular/core';
import { HttpClient,  HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class EstatusService {
  url = environment.urlWhats;
  constructor(private http: HttpClient) { }

  getAllEstatus(idAdmin, id, role, token, urlBack){
    const headers = new HttpHeaders()
    .set('rol-token', token);
    return this.http.get(`${urlBack}/obtenerListaEstatus/${idAdmin}/${id}/${role}`, {headers});

  }

  borrarEstatus(idAdmin, idRespuesta, id, role, token, urlBack){
    const headers = new HttpHeaders()
    .set('rol-token', token);
    return this.http.delete(`${urlBack}/eliminarEstatus/${idAdmin}/${idRespuesta}/${id}/${role}?ad_planIt=true`, {headers});

  }


  agregarEstatus(data, id, role, token, urlBack){
    const headers = new HttpHeaders()
    .set('rol-token', token);
    return this.http.post(`${urlBack}/agregarEstatus/${id}/${role}?ad_planIt=true`, data, {headers});

  }

  editarEstatus(data, idStatus, id, role, token, urlBack){
    const headers = new HttpHeaders()
    .set('rol-token', token);
    return this.http.put(`${urlBack}/actualizarEstatus/${idStatus}/${id}/${role}?ad_planIt=true`, data, {headers});

  }


}
